import React from 'react'
import {
  Container,
  TextTitle,
  TextBody,
  Button,
  ListContainer,
  TextCaption
} from '@pmi/pmi-iqos-ds-react'
import { SummaryPrice, SummaryDropdown } from '@zyn-common/components'

const CheckoutSummary = ({
  cart,
  translations,
  handleCouponAction,
  isPurchaseEnabled,
  purchase,
  compact,
  isUpgrade
}) => {
  return (
    <>
      <Container
        fullWidth
        bg={[Container.backgrounds.hardWhite, Container.backgrounds.white]}>
        <Container py="10" px="8">
          <Container>
            <Container pb="8">
              <TextCaption
                size={TextCaption.sizes.m}
                additionalClasses="q-text-turquoise">
                {translations.tk_cartSummary}
              </TextCaption>
            </Container>
            <SummaryPrice
              surchargeValue={cart.surchargeValue}
              surchargeTitle={cart.surchargeTitle}
              delivery={cart.delivery}
              deliveryFlat={cart.deliveryFlat}
              subtotal={cart.subtotal}
              discount={cart.discount}
              discountFlat={cart.discountFlat}
              translations={translations}
              promotions={cart.promotions}
              coupons={cart.coupons}
              handleCouponAction={handleCouponAction}
            />
            <Container
              pb={!compact ? '6' : '0'}
              pt="6"
              divider={Container.dividers.top}>
              <ListContainer columns={2} xBetween="2">
                <Container fullWidth>
                  <TextTitle heading={TextTitle.headings.h5}>
                    {translations.tk_summaryTotal}
                  </TextTitle>
                </Container>
                <Container fullWidth>
                  <TextTitle
                    heading={TextTitle.headings.h5}
                    alignment={TextBody.alignments.right}
                    data-testing="Checkout_TextTitle_Total">
                    {cart.total}
                  </TextTitle>
                </Container>
              </ListContainer>
            </Container>
            {!compact && (
              <Button
                fullWidth
                variant={Button.variants.primary}
                text={translations.tk_stepThreeConfirmOrder}
                onClickHandler={purchase}
                disabled={!isPurchaseEnabled}
                data-testing="Checkout_Button_Purchase"
              />
            )}
          </Container>
        </Container>
      </Container>
      {!compact && (
        <Container fullWidth pb="6">
          <SummaryDropdown
            cart={cart}
            isUpgrade={isUpgrade}
            translations={translations}
          />
        </Container>
      )}
    </>
  )
}

export default CheckoutSummary
